// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {buildHighOnRentalDaysPayload} from '../services/build-high-rental-days-payload';
import {
    getHighOnRentalDays
} from '../repositories';

export const highOnRentalDays = facets =>

async dispatch => {

    dispatch(busyCounter.increaseBusyCounter());

    const highOnRentalPayload = buildHighOnRentalDaysPayload(facets, '', '');

    try {

        const highOnRentalResults = await getHighOnRentalDays(highOnRentalPayload);

        dispatch({
            data: highOnRentalResults,
            type: actions.GET_HIGH_RENTAL_DAYS_PIN
        });

    } catch (error) {

    } finally {

        dispatch(busyCounter.decreaseBusyCounter());

    }

};



// WEBPACK FOOTER //
// ./src/product/shared/action-creators/high-rental-days.js